var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVertElipses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 17,
    viewBox: "0 0 5 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 9C2.63261 9 2.75979 8.94732 2.85355 8.85355C2.94732 8.75979 3 8.63261 3 8.5C3 8.36739 2.94732 8.24021 2.85355 8.14645C2.75979 8.05268 2.63261 8 2.5 8C2.36739 8 2.24021 8.05268 2.14645 8.14645C2.05268 8.24021 2 8.36739 2 8.5C2 8.63261 2.05268 8.75979 2.14645 8.85355C2.24021 8.94732 2.36739 9 2.5 9ZM2.5 15C2.63261 15 2.75979 14.9473 2.85355 14.8536C2.94732 14.7598 3 14.6326 3 14.5C3 14.3674 2.94732 14.2402 2.85355 14.1464C2.75979 14.0527 2.63261 14 2.5 14C2.36739 14 2.24021 14.0527 2.14645 14.1464C2.05268 14.2402 2 14.3674 2 14.5C2 14.6326 2.05268 14.7598 2.14645 14.8536C2.24021 14.9473 2.36739 15 2.5 15ZM2.5 3C2.63261 3 2.75979 2.94732 2.85355 2.85355C2.94732 2.75979 3 2.63261 3 2.5C3 2.36739 2.94732 2.24021 2.85355 2.14645C2.75979 2.05268 2.63261 2 2.5 2C2.36739 2 2.24021 2.05268 2.14645 2.14645C2.05268 2.24021 2 2.36739 2 2.5C2 2.63261 2.05268 2.75979 2.14645 2.85355C2.24021 2.94732 2.36739 3 2.5 3Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVertElipses);
export default __webpack_public_path__ + "static/media/vert_elipses.07c6927ab82e4b094e8db713b31ef285.svg";
export { ForwardRef as ReactComponent };